// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.table-scrollable {
  overflow-x: auto;
}

.shipment-th.mobile {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 4;
  background-color: white !important;
  text-align: center;
}

.shipment-th.mobile::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  border-bottom: 2px solid #dee2e6;
  border-right: 2px solid #dee2e6;
  width: 100%;
}

.shipment-td.mobile {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
}
@media (max-width: 1024px) {
  .shipment-td.mobile {
    background-color: #ffffff !important;
  }
}

.shipment-td.mobile::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0px;
  width: 1px;
  height: 100%;
  background-color: #dee2e6;
}

.button__shipment {
  width: 190px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__shipment.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__shipment {
    width: 120px;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}
.button__shipment-active {
  width: 150px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__shipment-active.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__shipment-active {
    width: 60px;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}
.button__shipment-noactive {
  width: 150px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__shipment-noactive.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__shipment-noactive {
    width: 80px;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}

.inactive {
  background-color: #ffffff; /* Белый фон для неактивной кнопки */
  color: #212529; /* Черный текст для неактивной кнопки */
}

.shipment__search {
  height: 30px;
  width: 100px;
  font-size: 14px;
  outline: none;
}
@media (max-width: 460px) {
  .shipment__search {
    width: 60px;
    height: 20px;
    font-size: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ShipmentList/modals/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,gBAAA;AAEJ;;AACA;EAEI,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;EACA,kBAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,gCAAA;EACA,+BAAA;EACA,WAAA;AACJ;;AAEA;EACI,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;AACJ;AAAI;EALJ;IAMQ,oCAAA;EAGN;AACF;;AAAA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAGJ;;AACE;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAEJ;AADI;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAGR;AADI;EAfF;IAgBM,YAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAIN;AACF;AAFI;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAIR;AAHQ;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAKZ;AAHQ;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAMV;AACF;AAHI;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAKR;AAJQ;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAMZ;AAJQ;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAOV;AACF;;AAHA;EACI,yBAAA,EAAA,oCAAA;EACA,cAAA,EAAA,uCAAA;AAMJ;;AAHA;EACI,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAMJ;AALI;EALJ;IAMQ,WAAA;IACA,YAAA;IACA,eAAA;EAQN;AACF","sourcesContent":[".table-scrollable {\n    overflow-x: auto;\n  }\n  \n.shipment-th.mobile {\n   \n    position: sticky;\n    left: 0;\n    top: 0;\n    z-index: 4;\n    background-color: white !important; \n    text-align: center;\n}\n\n.shipment-th.mobile::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    border-bottom: 2px solid #dee2e6;\n    border-right: 2px solid #dee2e6;\n    width: 100%;\n}\n\n.shipment-td.mobile {\n    position: sticky;\n    left: 0;\n    top: 0;\n    z-index: 3;\n    @media(max-width: 1024px) {\n        background-color: #ffffff !important;\n    }\n}\n\n.shipment-td.mobile::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0px;\n    width: 1px;\n    height: 100%;\n    background-color: #dee2e6;\n}\n\n\n  .button__shipment {\n    width: 190px;\n    height: 30px;\n    border: 1px solid #212529;\n    background-color: #212529;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    margin-right: 10px;\n    &.active {\n        background-color: #212529; /* Черный фон для активной кнопки */\n        color: #ffffff; /* Белый текст для активной кнопки */\n    }\n    @media(max-width: 460px) {\n        width: 120px;\n        height: 20px;\n        font-size: 10px;\n        margin-right: 5px;\n    }\n\n    &-active {\n        width: 150px;\n        height: 30px;\n        border: 1px solid #212529;\n        background-color: #212529;\n        color: #ffffff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n        margin-right: 10px;\n        &.active {\n            background-color: #212529; /* Черный фон для активной кнопки */\n            color: #ffffff; /* Белый текст для активной кнопки */\n        }\n        @media(max-width: 460px) {\n            width: 60px;\n            height: 20px;\n            font-size: 10px;\n            margin-right: 5px;\n        }\n    }\n\n    &-noactive {\n        width: 150px;\n        height: 30px;\n        border: 1px solid #212529;\n        background-color: #212529;\n        color: #ffffff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n        margin-right: 10px;\n        &.active {\n            background-color: #212529; /* Черный фон для активной кнопки */\n            color: #ffffff; /* Белый текст для активной кнопки */\n        }\n        @media(max-width: 460px) {\n            width: 80px;\n            height: 20px;\n            font-size: 10px;\n            margin-right: 5px;\n        }\n    }\n}\n\n.inactive {\n    background-color: #ffffff; /* Белый фон для неактивной кнопки */\n    color: #212529; /* Черный текст для неактивной кнопки */\n}\n\n.shipment__search {\n    height: 30px;\n    width: 100px;\n    font-size: 14px;\n    outline: none; \n    @media(max-width: 460px) {\n        width: 60px;\n        height: 20px;\n        font-size: 10px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
